import { ProductGender } from '@onrunning/backstage-models';

export const genderLetterMap = {
  [ProductGender.unisex]: 'U',
  [ProductGender.male]: 'M',
  [ProductGender.female]: 'W',
  [ProductGender.youth]: 'Y',
  [ProductGender.kids]: 'K',
  [ProductGender.toddler]: 'T',
};
